<template>
<section class="page-journal">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-journal-thumb">
    <div class="qbk-wrap">
      <div class="qbk-journal-heading">
        <h1>Our Promo</h1>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 mb-5" v-for="(pr,prindex) in promo" :key="'qbk-jt-item-'+prindex">
          <div class="qbk-jt-item">
            <router-link :to="`/promo/${pr.id}`">
              <img :src="pr.image" alt="" class="img-fluid w-100">
              <div class="qbk-jti-content">
                <h3>{{pr.title}}</h3>
                <h6>{{pr.summary}}</h6>
                <label>{{pr.date}}</label>
                <p>{{limitWord(pr.content,100)}}...</p>
                <span>Read More</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import axios from 'axios'
import {baseUrl} from '../config'
export default {
  name: 'promo',
  data() {
    return {
      promo : []
    };
  },
  methods: {
    loadPromo(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'PROMO ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.promo = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    thousand(num) {
      if (num) {
        let num_parts = num.toString().split(",");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(",");
      } else {
        return 0
      }
    },
    limitWord(yourString,maxLength){
      let string = yourString.replace(/<[^>]*>?/gm, '');
      var trimmedString = string.substr(0, maxLength);
      return trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  },
  mounted(){
    this.loadPromo()
  }
}
</script>
